import { useQuery, UseQueryResult } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { Party } from '../../../types';

export const getPartyById = async (partyId: string): Promise<Party> => {
  const path = `v1/api/parties/${partyId}`;
  const { data, isError } = await wgApi.get<Party>(path);
  if (isError) throw new Error();
  return data;
};

export const getUsePartyQKey = (partyId?: string) => ['party', partyId];

export const useParty = (partyId?: string): UseQueryResult<Party> => {
  return useQuery<Party>(
    getUsePartyQKey(partyId),
    () => getPartyById(partyId!),
    {
      refetchOnWindowFocus: false,
      enabled: !!partyId,
    },
  );
};
